import {
  stringify
} from 'query-string'
import axios from 'axios'
// // // 配置基准路径
axios.defaults.baseURL = 'https://mddoutsource.mddcloud.com.cn'
// axios.defaults.baseURL = 'http://47.106.221.72:9000/test/api/java-maiduidui'
// axios.defaults.baseURL = 'http://111.230.40.85:7288'

// 请求
const POST = function (url, param, fn) {
  axios({
    url: url,
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: stringify(param)
  }).then(res => {
    // if (res.data.errorCode == 2) {
    //   router.push('/');
    //   return
    // }
    fn(res.data)
  })
}
// 请求
const POSTONE = function (url, param, fn) {
  axios({
    url: url,
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    responseType: 'blob',
    data: stringify(param)
  }).then(res => {
    // if (res.data.errorCode == 2) {
    //   router.push('/');
    //   return
    // }
    fn(res.data)
  })
}
const POSTTWO = function (url, param, fn) {
  const toast1 = this.$toast.loading({
    duration: 0, // 持续展示 toast
    forbidClick: true,
    message: '加载中...'
  })
  axios({
    url: url,
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: stringify(param)
  }).then(res => {
    toast1.clear()
    // if (res.data.errorCode == 2) {
    //   router.push('/');
    //   return
    // }
    fn(res.data)
  })
}
// 请求
const GET = function (url, param, fn) {
  axios({
    url: url,
    method: 'GET',
    params: param
  }).then(res => {
    // if (res.data.errorCode == 2) {
    //   router.push('/');
    //   return
    // }
    fn(res.data)
  })
}
// 请求
const GETONE = function (url, param, fn) {
  axios({
    url: url,
    method: 'GET',
    params: param,
    responseType: 'blob'
  }).then(res => {
    // if (res.data.errorCode == 2) {
    //   router.push('/');
    //   return
    // }
    fn(res.data)
  })
}
export {
  POST,
  GET,
  POSTONE,
  GETONE,
  POSTTWO
}
